export default {
  PLAY_BUTTON: "playButton",
  WITHOUT_LOADING_INTO_STOP: "withoutLoadingIntoStop",
  INITIAL_LOAD: "initialLoad",
  STUCK_ANIMATION: "stuckAnimation",
  LOADING_INTO_STOP: "loadingIntoStop",
  STOP_BUTTON: "stopButton",
  INTO_PLAY: "intoPlay"
};
